import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux'; 
import { sectionOffset } from '../../actions';
import { ABOUT_OFFSET } from '../../actions/types';
 
const AboutUs = (props) => {
    let aboutSection = useRef();
    useEffect(() => {
        props.sectionOffset(ABOUT_OFFSET, aboutSection.current.offsetTop);
    }, []);
    return (
        <>
            <section ref={aboutSection} id="aboutus" className="about">
                <div className="container">

                    <div className="section-title" data-aos="zoom-out">
                        <h2>About</h2>
                        <p>Who we are</p>
                    </div>

                    <div className="row content" data-aos="fade-up">
                        <div className="col-lg-6">
                            <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
                            magna aliqua.
                            </p>
                            <ul>
                            <li><i className="ri-check-double-line"></i> Ullamco laboris nisi ut aliquip ex ea commodo consequat</li>
                            <li><i className="ri-check-double-line"></i> Duis aute irure dolor in reprehenderit in voluptate velit</li>
                            <li><i className="ri-check-double-line"></i> Ullamco laboris nisi ut aliquip ex ea commodo consequat</li>
                            </ul>
                        </div>
                        <div className="col-lg-6 pt-4 pt-lg-0">
                            <p>
                            Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
                            velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                            culpa qui officia deserunt mollit anim id est laborum.
                            </p>
                            <a href="#" className="btn-learn-more">Learn More</a>
                        </div>
                    </div>

                </div>
            </section>
            <section id="features" className="features">
                <div className="container">

                    <ul className="nav nav-tabs row d-flex">
                    <li className="nav-item col-3" data-aos="zoom-in">
                        <a className="nav-link active show" data-bs-toggle="tab" href="#tab-1">
                        <i className="ri-gps-line"></i>
                        <h4 className="d-none d-lg-block">Modi sit est dela pireda nest</h4>
                        </a>
                    </li>
                    <li className="nav-item col-3" data-aos="zoom-in" data-aos-delay="100">
                        <a className="nav-link" data-bs-toggle="tab" href="#tab-2">
                        <i className="ri-body-scan-line"></i>
                        <h4 className="d-none d-lg-block">Unde praesenti mara setra le</h4>
                        </a>
                    </li>
                    <li className="nav-item col-3" data-aos="zoom-in" data-aos-delay="200">
                        <a className="nav-link" data-bs-toggle="tab" href="#tab-3">
                        <i className="ri-sun-line"></i>
                        <h4 className="d-none d-lg-block">Pariatur explica nitro dela</h4>
                        </a>
                    </li>
                    <li className="nav-item col-3" data-aos="zoom-in" data-aos-delay="300">
                        <a className="nav-link" data-bs-toggle="tab" href="#tab-4">
                        <i className="ri-store-line"></i>
                        <h4 className="d-none d-lg-block">Nostrum qui dile node</h4>
                        </a>
                    </li>
                    </ul>

                    <div className="tab-content" data-aos="fade-up">
                    <div className="tab-pane active show" id="tab-1">
                        <div className="row">
                        <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0">
                            <h3>Voluptatem dignissimos provident quasi corporis voluptates sit assumenda.</h3>
                            <p className="fst-italic">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
                            magna aliqua.
                            </p>
                            <ul>
                            <li><i className="ri-check-double-line"></i> Ullamco laboris nisi ut aliquip ex ea commodo consequat.</li>
                            <li><i className="ri-check-double-line"></i> Duis aute irure dolor in reprehenderit in voluptate velit.</li>
                            <li><i className="ri-check-double-line"></i> Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate trideta storacalaperda mastiro dolore eu fugiat nulla pariatur.</li>
                            </ul>
                            <p>
                            Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
                            velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                            culpa qui officia deserunt mollit anim id est laborum
                            </p>
                        </div>
                        <div className="col-lg-6 order-1 order-lg-2 text-center">
                            <img src="assets/img/features-1.png" alt="" className="img-fluid"/>
                        </div>
                        </div>
                    </div>
                    <div className="tab-pane" id="tab-2">
                        <div className="row">
                        <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0">
                            <h3>Neque exercitationem debitis soluta quos debitis quo mollitia officia est</h3>
                            <p>
                            Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
                            velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                            culpa qui officia deserunt mollit anim id est laborum
                            </p>
                            <p className="fst-italic">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
                            magna aliqua.
                            </p>
                            <ul>
                            <li><i className="ri-check-double-line"></i> Ullamco laboris nisi ut aliquip ex ea commodo consequat.</li>
                            <li><i className="ri-check-double-line"></i> Duis aute irure dolor in reprehenderit in voluptate velit.</li>
                            <li><i className="ri-check-double-line"></i> Provident mollitia neque rerum asperiores dolores quos qui a. Ipsum neque dolor voluptate nisi sed.</li>
                            <li><i className="ri-check-double-line"></i> Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate trideta storacalaperda mastiro dolore eu fugiat nulla pariatur.</li>
                            </ul>
                        </div>
                        <div className="col-lg-6 order-1 order-lg-2 text-center">
                            <img src="assets/img/features-2.png" alt="" className="img-fluid"/>
                        </div>
                        </div>
                    </div>
                    <div className="tab-pane" id="tab-3">
                        <div className="row">
                        <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0">
                            <h3>Voluptatibus commodi ut accusamus ea repudiandae ut autem dolor ut assumenda</h3>
                            <p>
                            Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
                            velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                            culpa qui officia deserunt mollit anim id est laborum
                            </p>
                            <ul>
                            <li><i className="ri-check-double-line"></i> Ullamco laboris nisi ut aliquip ex ea commodo consequat.</li>
                            <li><i className="ri-check-double-line"></i> Duis aute irure dolor in reprehenderit in voluptate velit.</li>
                            <li><i className="ri-check-double-line"></i> Provident mollitia neque rerum asperiores dolores quos qui a. Ipsum neque dolor voluptate nisi sed.</li>
                            </ul>
                            <p className="fst-italic">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
                            magna aliqua.
                            </p>
                        </div>
                        <div className="col-lg-6 order-1 order-lg-2 text-center">
                            <img src="assets/img/features-3.png" alt="" className="img-fluid"/>
                        </div>
                        </div>
                    </div>
                    <div className="tab-pane" id="tab-4">
                        <div className="row">
                        <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0">
                            <h3>Omnis fugiat ea explicabo sunt dolorum asperiores sequi inventore rerum</h3>
                            <p>
                            Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
                            velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                            culpa qui officia deserunt mollit anim id est laborum
                            </p>
                            <p className="fst-italic">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
                            magna aliqua.
                            </p>
                            <ul>
                            <li><i className="ri-check-double-line"></i> Ullamco laboris nisi ut aliquip ex ea commodo consequat.</li>
                            <li><i className="ri-check-double-line"></i> Duis aute irure dolor in reprehenderit in voluptate velit.</li>
                            <li><i className="ri-check-double-line"></i> Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate trideta storacalaperda mastiro dolore eu fugiat nulla pariatur.</li>
                            </ul>
                        </div>
                        <div className="col-lg-6 order-1 order-lg-2 text-center">
                            <img src="assets/img/features-4.png" alt="" className="img-fluid"/>
                        </div>
                        </div>
                    </div>
                    </div>

                </div>
            </section>
            <section id="cta" className="cta">
                <div className="container">

                    <div className="row" data-aos="zoom-out">
                    <div className="col-lg-9 text-center text-lg-start">
                        <h3>Call To Action</h3>
                        <p> Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                    </div>
                    <div className="col-lg-3 cta-btn-container text-center">
                        <a className="cta-btn align-middle" href="#">Call To Action</a>
                    </div>
                    </div>

                </div>
            </section>
        </>
    );
}

export default connect(null, { sectionOffset })(AboutUs);